<template>
  <div>
    <div v-if="the_feed">
      <div v-if="!the_feed.itunes_detail" class="row">
        <div class="col-12">
          <div class="alert alert-outline-dark">
            <div class="alert-text">
              <p class="font-weight-bold">
                Your Feed does not have <a href="#feed_channel_portlet">Channel Information</a>. This must be populated in order to enable your Podcast Website.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-12 col-md-6">
          <div class="form-group kt-form__group row">
            <label class="col-6 col-md-1 col-form-label">Enabled</label>
            <div class="col-6 col-md-1">
              <span class="kt-switch kt-switch--icon">
                <label>
                  <input v-model="enabled" type="checkbox"
                         :checked="enabled"
                         name="enabled"
                         @change="toggleEnabled">
                  <span />
                </label>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="enabled" class="row">
        <div class="col-12 col-md-6">
          <div class="form-group kt-form__group">
            <label for="name">Name Override</label>
            <input id="name" v-model="podcast_website.name"
                   type="text"
                   class="form-control kt-input" placeholder="Uses Feed 'name' by default">
          </div>
        </div>
        <div class="w-100" />
        <div class="col-12 col-md-6">
          <div class="form-group kt-form__group">
            <label for="description">Description Override</label>
            <tip-tap v-model="podcast_website.description"
                     input-id="description"
                     placeholder="Uses Feed 'description' by default" />
          </div>
        </div>
        <div class="w-100" />
        <div class="col-12 col-md-6">
          <div class="form-group kt-form__group">
            <label for="ga_code">GA Tracking Code</label>
            <input id="ga_code" v-model="podcast_website.ga_code"
                   type="text"
                   class="form-control kt-input">
          </div>
        </div>
      </div>
      <div v-if="enabled" class="row">
        <div class="col-12">
          <button type="button" class="btn btn-ss-standout" @click="updatePodcastWebsite">
            Update
          </button>
          <a :href="podcast_website.url" class="btn btn-ss ml-2" target="_blank">
            View Website
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PodcastWebsiteMixin from "VueMixins/PodcastWebsiteMixin";

export default {
  mixins: [PodcastWebsiteMixin],
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      podcast_website: {
        name: null,
        description: null,
        ga_code: null,
      },
    };
  },
  beforeMount() {
    // Create non-reactive copy of the feed.
    this.the_feed = JSON.parse(JSON.stringify(this.feed));
  },
};
</script>
